import { render } from "./StaticNutzungsbedingungen.vue?vue&type=template&id=f85910f2"
import script from "./StaticNutzungsbedingungen.vue?vue&type=script&lang=js"
export * from "./StaticNutzungsbedingungen.vue?vue&type=script&lang=js"

import "./StaticNutzungsbedingungen.vue?vue&type=style&index=0&id=f85910f2&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__